<template>
  <div class="container">
    <div class="row" v-if="!noTitle">
      <div class="col-m-8">
        <article class="article mt-60 mb-30">
          <h3>Готовые решения</h3>
        </article>
      </div>
    </div>
    <div class="row">
      <div class="col-m-4 col-s-6">
        <div class="equip-item">
          <div class="equip-item__image">
            <img :src="require('@/assets/img/kiosks/49.jpg')" />
          </div>
          <div class="equip-item__title">Киоск напольный 49-65 дюймов</div>
          <div class="equip-item__description">1920x1080, металл 2-3мм, угол обзора 178° / 178°, Intel Core i5/4Gb/500Gb/Int. VGA, Sound, LAN, Windows 10 Pro Rus, гарантия 24 месяца.</div>
          <div class="equip-item__price">от 238 000 рублей*</div>
          <router-link to="/equip-request?type=vega" class="button button--small button--outlined">Оставить заявку</router-link>
        </div>
      </div>
      <div class="col-m-4 col-s-6">
        <div class="equip-item">
          <div class="equip-item__image">
            <img :src="require('@/assets/img/kiosks/sirius.jpg')" />
          </div>
          <div class="equip-item__title">Киоск напольный 19-49 дюймов</div>
          <div class="equip-item__description">1920x1080, металл 2-3мм, угол обзора 178° / 178°, Intel NUC i3/4Gb/SSD120Gb, MS Windows 10 Pro Rus, гарантия 24 месяца.</div>
          <div class="equip-item__price">от 175 000 рублей*</div>
          <router-link to="/equip-request?type=sirius" class="button button--small button--outlined">Оставить заявку</router-link>
        </div>
      </div>
      <div class="col-m-4 col-s-6">
        <div class="equip-item">
          <div class="equip-item__image">
            <img :src="require('@/assets/img/kiosks/wall.jpg')" />
          </div>
          <div class="equip-item__title">Киоск настенный 19-65 дюймов</div>
          <div class="equip-item__description">1920x1080, металл 1.5мм, угол обзора 178° / 178°, Intel Core i5/4Gb/500Gb/Int. VGA, Sound, LAN, Windows 10 Pro Rus, гарантия 24 месяца.</div>
          <div class="equip-item__price">от 166 000 рублей*</div>
          <router-link to="/equip-request?type=wall" class="button button--small button--outlined">Оставить заявку</router-link>
        </div>
      </div>
    </div>
    <div class="article">
      <p class="small">*Цены указаны для минимальной диагонали и комплектации. Точную цену уточняйте у менеджера с учетом конечной комплектации и транспортировки.</p>
    </div>
  </div>
</template>
<script>
const name = 'Equipment'

const props = {
  noTitle: {
    type: Boolean,
    default: false
  }
}

export default {
  name,
  props
}

</script>
